module.exports = __webpack_public_path__ + "img/white_workers.684300d8.svg";